import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import { Page } from '../interfaces/Page';
import { ProtectedContainerProps } from '../interfaces/PagesProps';
import PageContext from '../components/PageContext';

const getPage = (
  page: Page,
  isAuthenticated: boolean,
  ProtectedContainer: FC<ProtectedContainerProps>,
) => {
  const Container = page.protected || isAuthenticated ? ProtectedContainer : React.Fragment;
  const pathToUse = `${page.path}${page.exact ? '' : '/*'}`;

  return (
    <Route
      key={pathToUse}
      path={pathToUse}
      index={page.index}
      element={
        <PageContext.Provider value={page}>
          <Container>
            {page.component}
          </Container>
        </PageContext.Provider>
      }
    />
  );
};

export default getPage;
